import { GGOBaseComponent, RESTUtils } from '@galigeo-store/ui-lib';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { PortalAppContext } from '../../../state/portal-appcontext.js';
import { RightPanel } from '../../right-panel/right-panel.component.js';
import '../general/logs.admin.component.js';
import { publish, PUBSUB_TOPICS } from '../../../state/pubsub.js';

@customElement('admin-header')
export class AdminRightPanel extends GGOBaseComponent {
  @property({ type: String }) title = '';
  static get styles() {
    return [...super.styles];
  }

  constructor() {
    super();
  }

  render() {
    return html`
      <div class="slds-text-align_center slds-m-around_medium">
        <ggo-icon
          @click="${() => {
        publish(PUBSUB_TOPICS.GO_TO_ADMIN);
      }}"
          class="slds-float_left"
          icon="utility:back"
          size="small"
        ></ggo-icon>
        <h2 class="slds-text-heading_medium">${this.title}</h2>
      </div>
    `;
  }
}
